var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"~click":function($event){return _vm.goBack($event)}}},[_vm._v("Go Back")])])}
var staticRenderFns = []

export { render, staticRenderFns }